import { EventType } from "./event.js";
import { attachmentIngestEventReducer } from "./eventReducers/attachmentReducers.js";
import { taskIngestEventReducer, taskRepetitionEventReducer, taskRescheduleEventReducer, taskUpdateDeletedEventReducer, taskUpdateProvenanceEventReducer, taskUpdateSpecEventReducer, taskUpdateMetadataEventReducer, } from "./eventReducers/taskReducers.js";
const reducers = {
    [EventType.TaskIngest]: taskIngestEventReducer,
    [EventType.TaskRepetition]: taskRepetitionEventReducer,
    [EventType.TaskReschedule]: taskRescheduleEventReducer,
    [EventType.TaskUpdateDeleted]: taskUpdateDeletedEventReducer,
    [EventType.TaskUpdateSpecEvent]: taskUpdateSpecEventReducer,
    [EventType.TaskUpdateProvenanceEvent]: taskUpdateProvenanceEventReducer,
    [EventType.TaskUpdateMetadataEvent]: taskUpdateMetadataEventReducer,
    [EventType.AttachmentIngest]: attachmentIngestEventReducer,
};
export function eventReducer(entitySnapshot, event) {
    const reducer = reducers[event.type];
    if (reducer) {
        // Not sure why TS can't figure this one out...
        const typedReducer = reducer;
        return typedReducer(entitySnapshot, event);
    }
    else {
        throw new Error(`Unsupported event type ${event.type}`);
    }
}
//# sourceMappingURL=eventReducer.js.map